import {
  actionRequestShortLink,
  actionReceiveShortLink,
} from 'Actions';

import assembleFetchParams from './assembleFetchParams';

export default function fetchShortUrl() {
  return (dispatch) => {
    dispatch(actionRequestShortLink());
    if (!window.ajaxurl) {
      dispatch(actionReceiveShortLink(window.location.href));
      return Promise.resolve();
    }

    const {
      ajaxUrl,
      action,
      dest,
      security,
      title,
      desc,
    } = assembleFetchParams();

    return fetch(`${ajaxUrl}?${action}&${dest}&${security}&${title}&${desc}`)
      .then((response) => response.json())
      .then((shortened) => {
        dispatch(actionReceiveShortLink(shortened.data.replace(/\\|"/g, '')));
      })
      .catch(dispatch(actionReceiveShortLink(window.location.href)));
  };
}



// WEBPACK FOOTER //
// ./app/services/fetchShortUrl.js